// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_r4-5";
export var filledCircle = "_r4-4";
export var historyEntry = "_r4-3";
export var messageSideLeft = "_r4-1";
export var messageSideRight = "_r4-2";
export var orderTrackingCarouselWrapper = "_r4-6";
export var orderTrackingInfoContainer = "_r4-0";